import React from 'react';

import classes from './MButton.module.scss';
import { condClass } from 'app/utils/general';

interface Props {
  className?: string;
  type?: JSX.IntrinsicElements['button']['type'];
  disabled?: boolean;
  onClick?: () => void;
}

const MButtonView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <button
      onClick={props.onClick}
      className={condClass({
        [classes['container']]: true,
        [String(props.className)]: !!props.className,
      })}
      type={props.type}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
};

MButtonView.displayName = 'MButtonView';
MButtonView.defaultProps = {};

export default MButtonView;
